import _ from 'lodash';

function getHeader(headers: Record<string, string>, name: string) {
    return (Object.entries(headers) || []).find(
        ([k]) => k.toLowerCase() === name.toLowerCase()
    )?.[1];
}

function parseContentDisposition(contentDisposition: string) {
    return Object.fromEntries(
        contentDisposition
            .split(';')
            .map(x => x.trim())
            .map(p => {
                const [k, v] = p.split('=').map(x => _.trim(x, ' "'));
                return [k.toLowerCase(), v];
            })
    );
}

export function getFilenameFromHeaders(
    headers: Record<string, string>,
    fallback: string
): string {
    const contentDisposition = getHeader(headers, 'content-disposition') || '';
    const filename = decodeURIComponent(
        parseContentDisposition(contentDisposition)?.filename
    );
    return filename || fallback;
}
